import { useMemo } from "react"
import { Autocomplete, Stack, TextField } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Repeat } from "lib/@components/repeat"
import { AutocompleteTagChip } from "./autocomplete-tag-chip"

export function ConditionValueRegimeField({ value, onChange }) {
    const { regimeData } = useBoundContext()
    const fields = regimeData?.regimeFields || []
    const fieldOptions = useMemo(buildFieldOptions, [fields])

    const selectedField = value?.field || null
    const selectedValues = Array.isArray(value?.values) ? value.values : []
    const fieldDef = fields.find(isSelectedField)
    const valueOptions = fieldDef?.values || []

    return (
        <Stack spacing={1}>
            <Autocomplete
                fullWidth
                options={fieldOptions}
                getOptionLabel={getFieldLabel}
                isOptionEqualToValue={isFieldEqual}
                value={fieldOptions.find((o) => o.value === selectedField) || null}
                onChange={handleFieldChange}
                renderInput={renderFieldInput}
            />
            <If value={selectedField}>
                <Autocomplete
                    multiple
                    freeSolo
                    fullWidth
                    options={valueOptions}
                    value={selectedValues}
                    onChange={handleValuesChange}
                    renderInput={renderValuesInput}
                    renderTags={renderTags}
                />
            </If>
        </Stack>
    )

    function buildFieldOptions() {
        return fields.map((f) => ({ value: f.field, label: f.label }))
    }

    function isSelectedField(f) {
        return f.field === selectedField
    }

    function handleFieldChange(_, selected) {
        onChange({ field: selected?.value || null, values: [] })
    }

    function handleValuesChange(_, newValues) {
        onChange({ field: selectedField, values: newValues })
    }

    function getFieldLabel(option) {
        return typeof option === "string" ? option : option.label || ""
    }

    function isFieldEqual(option, val) {
        return option?.value === val?.value
    }

    function renderFieldInput(params) {
        return <TextField {...params} placeholder="Select regime field..." />
    }

    function renderValuesInput(params) {
        return <TextField {...params} placeholder={selectedValues.length === 0 ? "Select values..." : ""} />
    }

    function renderTags(tags, getTagProps) {
        return (
            <Stack direction="row" sx={{ flexWrap: "wrap", gap: 0.5 }}>
                <Repeat list={tags} item={<AutocompleteTagChip getTagProps={getTagProps} />} />
            </Stack>
        )
    }
}
